import { Flex, ListItem, OrderedList, type ListProps } from "@chakra-ui/react";
import React from "react";

type Props = {
  steps: string[];
  currentStep: number;
} & ListProps;

export function ProgressStepper({ steps, currentStep, ...props }: Props) {
  return (
    <OrderedList spacing={9} ml="0" pl="0" fontSize="lg" styleType="none" fontWeight="semibold" {...props}>
      {steps.map((step, idx) => {
        // Use black color for text and number for the current and all previous steps
        const stepNumber = idx + 1;
        const stepColor = stepNumber <= currentStep ? "text.primary" : "brand.textSecondary.light";

        return (
          <ListItem key={stepNumber} aria-label={step} color={stepColor} display="flex">
            <Flex
              align="center"
              bg={stepColor}
              boxSize="24px"
              flexShrink="0"
              borderRadius="100%"
              color="white"
              fontSize="14px"
              fontWeight="bold"
              justify="center"
              mr="3"
            >
              {stepNumber}
            </Flex>
            {step}
          </ListItem>
        );
      })}
    </OrderedList>
  );
}
